// @flow
import axios from 'lib/defaultClient';

export const like = (productId: string) => axios.post(`/products/${productId}/like`);

export const unlike = (productId: string) => axios.delete(`/products/${productId}/like`);

export const getLikesCount = (productId: string) => axios.get(`/products/${productId}/like`);



// WEBPACK FOOTER //
// ./src/lib/api/products/like.js